import fraseIkon from "../../assets/icons/Frasebibliotek-ikon.svg";
import documentIcon from "../../assets/icons/Opret-fraser-ikon.svg";
import cloudIcon from "../../assets/icons/Cloud-ikon.svg";
import computerIcon from "../../assets/icons/Autosuggestion-ikon.svg";
import protectionIcon from "../../assets/icons/protection-1652507.svg";
import "../../assets/css/tabs.css";

interface TabsProps {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}

export default function Tabs({ activeTab, setActiveTab }: TabsProps) {
  return (
    <div>
      <ul
        className="mr-10 flex list-none flex-col flex-wrap pl-0"
        role="tablist"
        data-te-nav-ref
      >
        <li
          role="presentation"
          onClick={() => setActiveTab(0)}
          className={`flex-grow text-center relative mb-6 active ${
            0 === activeTab ? "active-tab" : ""
          }`}
        >
          <a
            href="#bibliotek-af-fraser"
            className="my-2 flex items-center border-x-0 text-left border-b-2 border-t-0 border-transparent px-7 pb-3.5 pt-4 font-medium text-doctio-dark"
            data-te-toggle="pill"
            data-te-target="#bibliotek-af-fraser"
            data-te-nav-active
            role="tab"
            aria-controls="bibliotek-af-fraser"
            aria-selected="true"
          >
            <img
              src={fraseIkon}
              alt="Kvalitets ikon"
              className="w-[50px] mr-10"
            />
            Stort bibliotek af fraser og journalkoncepter
          </a>
        </li>
        <li
          role="presentation"
          onClick={() => setActiveTab(1)}
          className={`flex-grow text-center relative mb-6 ${
            1 === activeTab ? "active-tab" : ""
          }`}
        >
          <a
            href="#opret-fraser"
            className="my-2 flex items-center border-x-0 text-left border-b-2 border-t-0 border-transparent px-7 pb-3.5 pt-4 font-medium text-doctio-dark"
            data-te-toggle="pill"
            data-te-target="#opret-fraser"
            role="tab"
            aria-controls="opret-fraser"
            aria-selected="false"
          >
            <img
              src={documentIcon}
              alt="Dokument ikon"
              className="w-[50px] mr-10"
            />
            Opret dine egne fraser, og personliggør Doctios fraser
          </a>
        </li>
        <li
          role="presentation"
          onClick={() => setActiveTab(2)}
          className={`flex-grow text-center relative mb-6 ${
            2 === activeTab ? "active-tab" : ""
          }`}
        >
          <a
            href="#cloud-teknologi"
            className="my-2 flex items-center border-x-0 text-left border-b-2 border-t-0 border-transparent px-7 pb-3.5 pt-4 font-medium text-doctio-dark"
            data-te-toggle="pill"
            data-te-target="#cloud-teknologi"
            role="tab"
            aria-controls="cloud-teknologi"
            aria-selected="false"
          >
            <img src={cloudIcon} alt="Cloud ikon" className="w-[50px] mr-10" />
            Cloudbaseret teknologi der virker på tværs af journalsystemer
          </a>
        </li>
        <li
          role="presentation"
          onClick={() => setActiveTab(3)}
          className={`flex-grow text-center relative mb-6 ${
            3 === activeTab ? "active-tab" : ""
          }`}
        >
          <a
            href="#makrofunktion"
            className="my-2 flex items-center border-x-0 text-left border-b-2 border-t-0 border-transparent px-7 pb-3.5 pt-4 font-medium text-doctio-dark"
            data-te-toggle="pill"
            data-te-target="#makrofunktion"
            role="tab"
            aria-controls="makrofunktion"
            aria-selected="false"
          >
            <img
              src={computerIcon}
              alt="Computer ikon"
              className="w-[50px] mr-10"
            />
            Dynamiske fraser med indbygget logik og DoctioAssist
          </a>
        </li>
        <li
          role="presentation"
          onClick={() => setActiveTab(4)}
          className={`flex-grow text-center relative mb-6 ${
            4 === activeTab ? "active-tab" : ""
          }`}
        >
          <a
            href="#gdpr"
            className="my-2 flex items-center border-x-0 text-left border-b-2 border-t-0 border-transparent px-7 pb-3.5 pt-4 font-medium text-doctio-dark"
            data-te-toggle="pill"
            data-te-target="#gdpr"
            role="tab"
            aria-controls="gdpr"
            aria-selected="false"
          >
            <img
              src={protectionIcon}
              alt="GDPR sikkert ikon"
              className="w-[40px] mr-10"
            />
            GDPR sikkert og øget juridisk sikkerhed
          </a>
        </li>
      </ul>
    </div>
  );
}
